module.exports = __webpack_public_path__ + "img/lock.469e02f3.svg";